var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-wrapper"},[_c('v-col',{attrs:{"cols":"12","lg":"10","md":"7"}},[_c('v-form',[_c('v-card',{staticClass:"card-shadow bg-secondary"},[_c('CadastroAgencia')],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }